import { render, staticRenderFns } from "./LogRoundSetNumber.vue?vue&type=template&id=0542c8ae&"
import script from "./LogRoundSetNumber.vue?vue&type=script&lang=js&"
export * from "./LogRoundSetNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports